var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { capitalizeFirstLetter } from "@frameworks/salesjourney/utils/genericMethods";
export var DpDetailsMapper = function (dpDetails) {
    var dpDetailsData = __assign({}, dpDetails);
    if ((dpDetails === null || dpDetails === void 0 ? void 0 : dpDetails.data) && (dpDetails === null || dpDetails === void 0 ? void 0 : dpDetails.data.length) > 0) {
        dpDetailsData["data"] = dpDetails === null || dpDetails === void 0 ? void 0 : dpDetails.data.map(function (record) {
            return {
                label: "".concat(record.dp_id, "(").concat(record.dp_acno, ") - ").concat(capitalizeFirstLetter(record.dp_name), " ").concat(record.dp_type),
                value: record.dp_id_acno,
            };
        });
    }
    return dpDetailsData;
};
